import { registerComponent as N } from "@aileron/button-icon";
import { unsafeCSS as F, LitElement as M } from "lit";
import { html as f, unsafeStatic as O } from "lit/static-html.js";
import { query as v, queryAssignedElements as R, property as k } from "lit/decorators.js";
import { classMap as x } from "lit/directives/class-map.js";
import { ifDefined as E } from "lit/directives/if-defined.js";
const H = (o) => {
  class e extends o {
    constructor(...r) {
      super(...r), this.fontLink = "https://www.aa.com/fonts/css/family/american-sans-variable.css";
      const a = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(a.getElementsByTagName("link")).findIndex(
        (c) => c.href === this.fontLink
      ) === -1) {
        const c = document.createElement("link");
        c.href = this.fontLink, c.rel = "stylesheet", document.head.appendChild(c);
      }
    }
  }
  return e;
}, K = '*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]:where(:not([hidden=until-found])){display:none}strong{font-weight:700;font-variation-settings:"wght" 700}.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.static{position:static}.-mt-px{margin-top:-1px}.mt-5{margin-top:1.25rem}.box-border{box-sizing:border-box}.inline{display:inline}.flex{display:flex}.hidden{display:none}.h-12{height:3rem}.h-9{height:2.25rem}.w-12{width:3rem}.w-9{width:2.25rem}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.cursor-pointer{cursor:pointer}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.items-center{align-items:center}.justify-center{justify-content:center}.rounded{border-radius:.25rem}.border{border-width:1px}.border-solid{border-style:solid}.border-blue-060{border-color:#0860c4}.border-blue-070{border-color:#0a78f5}.border-blue-080{border-color:#3b93f7}.border-neutral-050{border-color:#405164}.border-neutral-090{border-color:#b4c1cf}.border-transparent{border-color:transparent}.bg-blue-060{background-color:#0860c4}.bg-blue-070{background-color:#0a78f5}.bg-blue-080{background-color:#3b93f7}.bg-neutral-010{background-color:#181e25}.bg-neutral-020{background-color:#202832}.bg-neutral-030{background-color:#28323e}.bg-neutral-040{background-color:#303d4b}.bg-neutral-050{background-color:#405164}.bg-neutral-090{background-color:#b4c1cf}.bg-neutral-100{background-color:#e6eaef}.bg-neutral-110{background-color:#eceff3}.bg-neutral-120{background-color:#f3f5f7}.bg-neutral-130{background-color:#f9fafb}.bg-transparent{background-color:transparent}.p-0{padding:0}.text-blue-060{color:#0860c4}.text-blue-080{color:#3b93f7}.text-neutral-000{color:#101419}.text-neutral-050{color:#405164}.text-neutral-090{color:#b4c1cf}.text-neutral-140{color:#fff}.outline{outline-style:solid}.outline-2{outline-width:2px}.outline-offset-2{outline-offset:2px}.outline-blue-070{outline-color:#0a78f5}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}[hidden]{display:none!important}.hover\\:border-blue-070:hover{border-color:#0a78f5}.hover\\:bg-blue-070:hover{background-color:#0a78f5}.hover\\:bg-neutral-110:hover{background-color:#eceff3}.hover\\:bg-neutral-120:hover{background-color:#f3f5f7}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.focus\\:outline:focus{outline-style:solid}.focus\\:outline-2:focus{outline-width:2px}.focus\\:outline-offset-2:focus{outline-offset:2px}.focus\\:outline-blue-070:focus{outline-color:#0a78f5}.active\\:border-blue-080:active{border-color:#3b93f7}.active\\:bg-blue-080:active{background-color:#3b93f7}.active\\:bg-neutral-100:active{background-color:#e6eaef}.active\\:bg-neutral-110:active{background-color:#eceff3}.active\\:bg-neutral-120:active{background-color:#f3f5f7}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:border-neutral-090:disabled{border-color:#b4c1cf}.disabled\\:bg-neutral-090:disabled{background-color:#b4c1cf}.disabled\\:text-neutral-090:disabled{color:#b4c1cf}.dark\\:border-blue-080:is(:host([aileron-color-scheme=dark]) *){border-color:#3b93f7}.dark\\:bg-blue-080:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:text-blue-080:is(:host([aileron-color-scheme=dark]) *){color:#3b93f7}.dark\\:text-neutral-000:is(:host([aileron-color-scheme=dark]) *){color:#101419}.dark\\:hover\\:bg-blue-070:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#0a78f5}.dark\\:hover\\:bg-neutral-010:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#181e25}.dark\\:hover\\:bg-neutral-020:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:hover\\:bg-neutral-030:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:focus\\:bg-blue-080:focus:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:active\\:border-blue-060:active:is(:host([aileron-color-scheme=dark]) *){border-color:#0860c4}.dark\\:active\\:bg-blue-060:active:is(:host([aileron-color-scheme=dark]) *){background-color:#0860c4}.dark\\:active\\:bg-neutral-020:active:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:active\\:bg-neutral-030:active:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:active\\:bg-neutral-040:active:is(:host([aileron-color-scheme=dark]) *){background-color:#303d4b}.dark\\:disabled\\:border-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){border-color:#405164}.dark\\:disabled\\:bg-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){background-color:#405164}.dark\\:disabled\\:text-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){color:#405164}', U = F(K), w = "aileron-color-scheme", L = "aileron-color-scheme-change", j = (o) => {
  const t = class t extends o {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (a) => {
        a.detail ? this.setAttribute(w, a.detail) : this.removeAttribute(w);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        L,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const a = document.documentElement.getAttribute(
        w
      );
      a && this.setAttribute(w, a);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        L,
        this.handleSchemeSwitch
      );
    }
  };
  t.styles = [
    U,
    o.styles ?? []
  ];
  let e = t;
  return e;
}, $ = j(H(M));
function b(o, e, t) {
  return new Promise((r) => {
    if ((t == null ? void 0 : t.duration) === 1 / 0)
      throw new Error("Promise-based animation must be finite");
    const a = o.animate(e, {
      ...t,
      duration: I() ? 0 : t == null ? void 0 : t.duration
    });
    a == null || a.addEventListener("cancel", r, { once: !0 }), a == null || a.addEventListener("finish", r, { once: !0 });
  });
}
function I() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function y(o) {
  return Promise.all(
    o.getAnimations().map((e) => new Promise((t) => {
      const r = requestAnimationFrame(t);
      e.addEventListener("cancel", () => r, {
        once: !0
      }), e.addEventListener("finish", () => r, {
        once: !0
      }), e.cancel();
    }))
  );
}
class V {
  constructor(e) {
    this.userAgent = e;
  }
  getDevice() {
    return this.userAgent.match(/iPad/i) ? "iPad" : this.userAgent.match(/iPhone/i) ? "iPhone" : this.userAgent.match(/iPod/i) ? "iPod" : this.userAgent.match(/Android/i) ? "Android" : "Unknown";
  }
  getBrowser() {
    return this.userAgent.match(/chrome|chromium|crios/i) ? "Chrome" : this.userAgent.match(/firefox|fxios/i) ? "Firefox" : this.userAgent.match(/opr\//i) ? "Opera" : this.userAgent.match(/edg/i) ? "Edge" : this.userAgent.match(/safari/i) ? "Safari" : "Unknown";
  }
}
function u(o, e, t) {
  const r = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...t
  });
  return o.dispatchEvent(r), r;
}
function T(o, e) {
  return new Promise((t) => {
    function r(a) {
      a.target === o && (o.removeEventListener(e, r), t());
    }
    o.addEventListener(e, r);
  });
}
const W = (o, e, t) => Array.prototype.forEach.call(o, e, t);
function z(o) {
  const e = o.tagName.toLowerCase();
  return o.getAttribute("tabindex") === "-1" || o.hasAttribute("disabled") || o.hasAttribute("aria-disabled") && o.getAttribute("aria-disabled") !== "false" || e === "input" && o.getAttribute("type") === "radio" && !o.hasAttribute("checked") || window.getComputedStyle(o).visibility === "hidden" || window.getComputedStyle(o).display === "none" ? !1 : (e === "audio" || e === "video") && o.hasAttribute("controls") || o.hasAttribute("tabindex") || o.hasAttribute("contenteditable") && o.getAttribute("contenteditable") !== "false" ? !0 : [
    "button",
    "input",
    "select",
    "textarea",
    "a",
    "audio",
    "video",
    "summary"
  ].includes(e);
}
function P(o) {
  const e = /* @__PURE__ */ new Set();
  function t(i) {
    i instanceof HTMLElement && (e.add(i), i.tagName.toLowerCase() === "slot" && i.assignedElements().forEach((n) => t(n)), i.shadowRoot && i.shadowRoot.mode === "open" && t(i.shadowRoot)), (i instanceof ShadowRoot || i instanceof HTMLElement) && W(i.querySelectorAll("*"), (n) => {
      var c;
      ((c = n == null ? void 0 : n.tagName) == null ? void 0 : c.toLowerCase()) === "slot" || n.shadowRoot ? t(n) : e.add(n);
    });
  }
  t(o);
  const r = Array.from(e).find((i) => z(i)) ?? null, a = Array.from(e).reverse().find((i) => z(i)) ?? null;
  return { start: r, end: a };
}
let p = [];
class X {
  constructor(e) {
    this.tabDirection = "forward", this.element = e, this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  activate() {
    p.push(this.element), this.element.addEventListener("keydown", this.handleKeyDown);
    const { start: e, end: t } = P(this.element);
    this.start = e, this.end = t;
  }
  deactivate() {
    p = p.filter((e) => e !== this.element), document.removeEventListener("keydown", this.handleKeyDown);
  }
  isActive() {
    return p[p.length - 1] === this.element;
  }
  handleKeyDown(e) {
    if (e.key === "Tab") {
      const t = e.shiftKey ? this.start : this.end;
      this.getActiveElement(t) === t && (e.preventDefault(), t === this.end ? this.start.focus() : this.end.focus());
    }
  }
  updateTabbableElements() {
    const { start: e, end: t } = P(this.element);
    this.start = e, this.end = t;
  }
  getActiveElement(e) {
    return e.getRootNode().activeElement;
  }
}
const _ = /* @__PURE__ */ new Set();
function D(o) {
  _.add(o), document.body.classList.add("adc-scroll-lock"), document.body.style.overflow = "hidden", document.body.style.touchAction = "none";
}
function B(o) {
  _.delete(o), _.size === 0 && (document.body.classList.remove("adc-scroll-lock"), document.body.removeAttribute("style"));
}
class Y {
  constructor(e, ...t) {
    this.slotNames = [], (this.host = e).addController(this), this.slotNames = t, this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((e) => {
      var t;
      if (e.nodeType === e.TEXT_NODE && ((t = e.textContent) == null ? void 0 : t.trim()) !== "")
        return !0;
      if (e.nodeType === e.ELEMENT_NODE) {
        const r = e;
        if (r.tagName.toLowerCase() === "adc-visually-hidden")
          return !1;
        if (!r.hasAttribute("slot"))
          return !0;
      }
      return !1;
    });
  }
  hasNamedSlot(e) {
    return this.host.querySelector(`:scope > [slot="${e}"]`) !== null;
  }
  test(e) {
    return e === "[default]" ? this.hasDefaultSlot() : this.hasNamedSlot(e);
  }
  hostConnected() {
    var e;
    (e = this.host.shadowRoot) == null || e.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    var e;
    (e = this.host.shadowRoot) == null || e.removeEventListener(
      "slotchange",
      this.handleSlotChange
    );
  }
  handleSlotChange(e) {
    var r, a;
    const t = e.target;
    ((r = this.slotNames) != null && r.includes("[default]") && !t.name || t.name && ((a = this.slotNames) != null && a.includes(t.name))) && this.host.requestUpdate();
  }
}
function G(o, e) {
  const t = {
    waitUntilFirstUpdate: !1,
    ...e
  };
  return (r, a) => {
    const { update: i } = r;
    if (o in r) {
      const n = o;
      r.update = function(c) {
        if (c.has(n)) {
          const A = c.get(n), S = this[n];
          A !== S && (!t.waitUntilFirstUpdate || this.hasUpdated) && this[a](
            A,
            S
          );
        }
        i.call(this, c);
      };
    }
  };
}
const q = /* @__PURE__ */ new Map(), J = /* @__PURE__ */ new WeakMap();
function Q(o) {
  return o ?? { keyframes: [], options: { duration: 0 } };
}
function m(o, e) {
  q.set(o, Q(e));
}
function g(o, e) {
  const t = J.get(o);
  if (t != null && t[e])
    return t[e];
  const r = q.get(e);
  return r || {
    keyframes: [],
    options: { duration: 0 }
  };
}
const Z = ":host .aileron-dialog__container{align-items:center;justify-content:center;position:fixed;top:0;right:0;bottom:0;left:0;z-index:50;display:flex}:host .aileron-dialog__overlay{background-color:#000c;position:fixed;top:0;right:0;bottom:0;left:0}:host .aileron-dialog__panel{box-shadow:0 9px 46px 8px #0000001f,0 24px 38px 3px #00000024,0 11px 15px -7px #0003;border-radius:8px;width:auto;flex-direction:column;background-color:#fff;max-width:calc(100vw - 2rem);max-height:calc(100vh - 2rem);position:relative}:host .aileron-dialog__panel--fullwidth{height:100%}:host .aileron-dialog__header-container{flex:0 1 auto;padding:1.5rem;position:relative}:host .aileron-dialog__header{font-family:AmericanSans Var;font-weight:700;font-size:1.25rem;line-height:1.75rem;color:#1b1f23;margin:0 4px 0 0}:host .aileron-dialog__close-button{position:absolute;top:16px;right:16px;z-index:10;margin-left:24px}:host .aileron-dialog__body{font-family:AmericanSans Var;font-weight:400;font-size:1rem;color:#1b1f23;line-height:1.5rem;overflow:auto;margin-bottom:24px;padding-left:24px;padding-right:24px;flex:1 1 auto;-webkit-overflow-scrolling:touch}:host .aileron-dialog__body--without-header{margin-top:24px}:host .aileron-dialog__footer{padding-left:24px;padding-right:24px;padding-bottom:24px;flex:0 1 auto;justify-content:flex-end;display:flex}:host .aileron-dialog__footer--hidden{display:none}:host .aileron-dialog__image{display:flex;justify-content:center}:host .aileron-dialog__loading{min-height:300px}@media (min-width: 50rem){:host .aileron-dialog__panel{min-width:356px;max-width:546px;max-height:80vh}:host .aileron-dialog__panel--fullwidth{max-width:calc(100vw - 4rem)}}@media (min-width: 80rem){:host .aileron-dialog__panel{min-width:389px;max-width:596px}:host .aileron-dialog__panel--fullwidth{max-width:calc(100vw - 4rem)}}@media (min-width: 90rem){:host .aileron-dialog__panel--fullwidth{max-width:1216px}}:host([open]) .aileron-dialog__panel{display:flex;opacity:1}@media (prefers-color-scheme: dark){:host([aileron-color-scheme=dark]) .aileron-dialog__panel{background-color:#131313}:host([aileron-color-scheme=dark]) .aileron-dialog__header,:host([aileron-color-scheme=dark]) .aileron-dialog__body{color:#f9fafb}:host([aileron-color-scheme=dark]) .aileron-dialog__close-button::part(interactive){color:#3aabff}}:host{display:contents}";
var ee = Object.defineProperty, te = Object.getOwnPropertyDescriptor, h = (o, e, t, r) => {
  for (var a = r > 1 ? void 0 : r ? te(e, t) : e, i = o.length - 1, n; i >= 0; i--)
    (n = o[i]) && (a = (r ? n(e, t, a) : n(a)) || a);
  return r && a && ee(e, t, a), a;
};
const s = "aileron-dialog", d = {
  root: s,
  container: `${s}__container`,
  overlay: `${s}__overlay`,
  panel: `${s}__panel`,
  panelFullwidth: `${s}__panel--fullwidth`,
  header: `${s}__header`,
  headerContainer: `${s}__header-container`,
  body: `${s}__body`,
  bodyWithoutHeader: `${s}__body--without-header`,
  footer: `${s}__footer`,
  footerHidden: `${s}__footer--hidden`,
  closeButton: `${s}__close-button`,
  image: `${s}__image`,
  loading: `${s}__loading`
}, C = class C extends $ {
  constructor(e) {
    super(), this.hasSlotController = new Y(
      this,
      "footer",
      "label",
      "image",
      "loading"
    ), this.open = !1, this.noCloseButton = !1, this.variant = "message", this.mutationObserverCallback = async () => {
      await this.updateComplete, this.modal.updateTabbableElements();
    }, this.updateTabbableElements = () => {
      this.modal.updateTabbableElements();
    }, this.customElementString = e;
  }
  /**
   * Instantiates the modal and adds tab-index to the main dialog.
   */
  connectedCallback() {
    this.classList.add("adc-dialog"), N(
      this.customElementString ? this.customElementString + "-dialog" : "adc-dialog"
    ), super.connectedCallback(), this.modal = new X(this), this.tabIndex = -1;
  }
  /**
   * Toggles the dialog open/closed. If opened, initializes the modal, and
   * adds a style to lock body scrolling.
   */
  async firstUpdated() {
    const e = new V(navigator.userAgent), t = e.getDevice().toLowerCase(), r = e.getBrowser().toLowerCase();
    t !== "iphone" && t !== "ipad" && r !== "safari" && this.panel.setAttribute("aria-modal", "true"), this.dialog.hidden = !this.open, this.open && (await this.updateComplete, this.modal.activate(), D(this)), this.handleLoadingSlotChange();
    const a = new MutationObserver(this.mutationObserverCallback);
    this.defaultSlotEls.forEach((i) => {
      a.observe(i, {
        attributes: !0,
        childList: !0,
        subtree: !0,
        attributeFilter: ["style"]
      });
    });
  }
  /**
   * Removes the styles for locking body scrolling.
   */
  disconnectedCallback() {
    super.disconnectedCallback(), B(this);
  }
  /**
   * Handles the action for showing the dialog.
   * @returns {Promise<void>}|undefined
   */
  async show() {
    if (!this.open)
      return this.open = !0, T(this, "adc-after-show");
  }
  /**
   * Handles the action for hiding the dialog.
   * @returns {Promise<void>}|undefined
   */
  async hide() {
    if (this.open)
      return this.open = !1, T(this, "adc-after-hide");
  }
  /**
   * Handles setting focus to the panel when the dialog is shown.
   * @param options - standard focus options,
   * https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent/FocusEvent
   */
  focus(e) {
    this.panel.focus(e);
  }
  /**
   * Handles the action for closing the dialog, triggers `hide()` on success.
   * @fires adc-request-close - fires when the dialog is requested to close.
   * @param source "close-button" | "keyboard" | "overlay" - the source of the close event.
   * @returns
   */
  requestClose(e) {
    if (u(this, "adc-request-close", {
      cancelable: !0,
      detail: { source: e }
    }).defaultPrevented) {
      const r = g(this, "dialog.denyClose");
      try {
        b(this.panel, r.keyframes, r.options);
      } catch {
      }
      return;
    }
    this.hide();
  }
  /**
   * Handles the action for closing the dialog when the "Escape" key is pressed.
   * @param event - keyboard event for key detection
   */
  handleKeyDown(e) {
    e.key === "Escape" && (e.stopPropagation(), this.requestClose("keyboard"));
  }
  async handleOpenChange() {
    if (this.open) {
      u(this, "adc-show"), this.originalTrigger = document.activeElement, this.modal.activate(), D(this);
      const e = this.querySelector("[autofocus]");
      e && e.removeAttribute("autofocus");
      try {
        await Promise.all([
          y(this.dialog),
          y(this.overlay)
        ]);
      } catch {
      }
      this.dialog.hidden = !1, requestAnimationFrame(() => {
        u(this, "adc-initial-focus", {
          cancelable: !0
        }).defaultPrevented || (e ? e.focus({
          preventScroll: !0
        }) : this.focus({ preventScroll: !0 })), e && e.setAttribute("autofocus", "");
      });
      const t = g(this, "dialog.show"), r = g(this, "dialog.overlay.show");
      try {
        await Promise.all([
          b(
            this.panel,
            t.keyframes,
            t.options
          ),
          b(
            this.overlay,
            r.keyframes,
            r.options
          )
        ]);
      } catch {
      }
      u(this, "adc-after-show");
    } else {
      u(this, "adc-hide"), this.modal.deactivate();
      try {
        await Promise.all([
          y(this.dialog),
          y(this.overlay)
        ]);
      } catch {
      }
      const e = g(this, "dialog.hide"), t = g(this, "dialog.overlay.hide");
      try {
        await Promise.all([
          b(
            this.panel,
            e.keyframes,
            e.options
          ),
          b(
            this.overlay,
            t.keyframes,
            t.options
          )
        ]);
      } catch {
      }
      this.dialog.hidden = !0, B(this);
      const r = this.originalTrigger;
      typeof (r == null ? void 0 : r.focus) == "function" && setTimeout(() => r.focus()), u(this, "adc-after-hide");
    }
  }
  handleLoadingSlotChange() {
    this.isLoading = this.hasSlotController.test("loading");
  }
  renderLoading() {
    return f`<div class="${d.loading}">
      <slot @slotchange=${this.handleLoadingSlotChange} name="loading"></slot>
    </div>`;
  }
  renderHeader() {
    var e;
    return f` <div part="header" class="${d.headerContainer}">
      <div part="image" class="${d.image}">
        <slot name="image"></slot>
      </div>
      <h2 part="title" class="${d.header}" id="title">
        <slot name="label">
          ${((e = this.labelText) == null ? void 0 : e.length) > 0 ? this.labelText : void 0}
        </slot>
      </h2>
      ${this.noCloseButton ? void 0 : f`<${this.createTagName("-dialog-button-icon")}
            exportparts="button-icon: close-button"
            class="${d.closeButton}"
            kind="ghost"
            label-text="Close Dialog"
            icon="action:close"
            @click=${() => this.requestClose("close-button")}
            id="closeButton"
          >
          </${this.createTagName("-dialog-button-icon")}>`}
    </div>`;
  }
  renderPanelContent() {
    return f`
      ${this.labelText || !this.noCloseButton || this.hasSlotController.test("label") ? this.renderHeader() : void 0}
      <div
        part="body"
        id="dialogBody"
        class="${x({
      [d.body]: !0,
      [d.bodyWithoutHeader]: !this.labelText && !this.hasSlotController.test("label")
    })}"
      >
        <slot></slot>
      </div>
      <div
        part="footer"
        class="${x({
      [d.footer]: this.hasSlotController.test("footer"),
      [d.footerHidden]: !this.hasSlotController.test("footer")
    })}"
      >
        <slot name="footer"></slot>
      </div>
    `;
  }
  /**
   * @ignore
   */
  createTagName(e) {
    return O(
      this.customElementString ? this.customElementString + e : "adc" + e
    );
  }
  /**
   * Renders the full dialog and overlay components.
   * @returns {TemplateResult} - the template for the dialog.
   */
  render() {
    return f`
      <div
        id="dialog"
        part="base"
        class="${d.container}"
        @keydown=${this.handleKeyDown}
      >
        <div
          id="dialogOverlay"
          part="overlay"
          class="${d.overlay}"
          @click=${() => this.requestClose("overlay")}
          tabindex="-1"
        ></div>
        <div
          id="dialogPanel"
          part="panel"
          class="${x({
      [d.panel]: !0,
      [d.panelFullwidth]: this.variant === "fullscreen"
    })}"
          role="dialog"
          aria-hidden=${this.open ? "false" : "true"}
          aria-label=${E(this.labelText ? this.labelText : void 0)}
          aria-labelledby=${E(this.labelText ? void 0 : "title")}
          tabindex="-1"
        >
          ${this.isLoading ? this.renderLoading() : this.renderPanelContent()}
        </div>
      </div>
    `;
  }
};
C.styles = [$.styles || [], F(Z)];
let l = C;
h([
  v("#dialog")
], l.prototype, "dialog", 2);
h([
  v("#dialogPanel")
], l.prototype, "panel", 2);
h([
  v("#dialogBody")
], l.prototype, "body", 2);
h([
  v("#dialogOverlay")
], l.prototype, "overlay", 2);
h([
  R()
], l.prototype, "defaultSlotEls", 2);
h([
  k({ type: Boolean, reflect: !0 })
], l.prototype, "open", 2);
h([
  k({ attribute: "label-text" })
], l.prototype, "labelText", 2);
h([
  k({ type: Boolean, attribute: "no-close-button", reflect: !0 })
], l.prototype, "noCloseButton", 2);
h([
  k()
], l.prototype, "variant", 2);
h([
  G("open", { waitUntilFirstUpdate: !0 })
], l.prototype, "handleOpenChange", 1);
m("dialog.show", {
  keyframes: [
    { opacity: 0, transform: "scale(0.8)" },
    { opacity: 1, transform: "scale(1)" }
  ],
  options: {
    duration: 250,
    easing: "ease"
  }
});
m("dialog.hide", {
  keyframes: [
    { opacity: 1, transform: "scale(1)" },
    { opacity: 0, transform: "scale(0.8)" }
  ],
  options: {
    duration: 250,
    easing: "ease"
  }
});
m("dialog.denyClose", {
  keyframes: [
    { transform: "scale(1)" },
    { transform: "scale(1.02)" },
    { transform: "scale(1)" }
  ],
  options: {
    duration: 250
  }
});
m("dialog.overlay.show", {
  keyframes: [{ opacity: 0 }, { opacity: 1 }],
  options: {
    duration: 250
  }
});
m("dialog.overlay.hide", {
  keyframes: [{ opacity: 1 }, { opacity: 0 }],
  options: {
    duration: 250
  }
});
try {
  customElements.define("adc-dialog", l), console.warn(
    "@aileron/dialog is deprecated. Please use @aileron/lit-components instead. For migration documentation, see https://aileron.aa.com/components/dialog"
  );
} catch {
}
function oe(o) {
  try {
    customElements.define(
      `${o}-dialog`,
      class extends l {
        constructor() {
          super(o);
        }
      }
    );
  } catch {
  }
}
function de(o) {
  try {
    oe(o);
  } catch {
  }
}
export {
  l as Dialog,
  de as registerComponent,
  oe as registerDialog
};
